// extracted by mini-css-extract-plugin
export default {"selectButton":"TableControl-module__selectButton--y5Fqu","selected":"TableControl-module__selected--lkE_6","animatedBackground":"TableControl-module__animatedBackground--CwtoS"};